import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

// material-ui
import { Box, Drawer } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import MenuList from './MenuList';
import { drawerWidth } from '../../store/constant';

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    const theme = useTheme();
    const [scrollEl, setScrollEl] = useState();
    useEffect(() => {
      if (scrollEl) {
        scrollEl.scrollTop = 100;
      }
    }, [scrollEl]);
    const drawer = (
        <>
                <PerfectScrollbar
                    component="div"
                    containerRef={ref => {
                        setScrollEl(ref);
                    }}
                    style={{
                        paddingLeft: '16px',
                        paddingRight: '16px',
                        paddingBottom: '50px'
                    }}
                >
                <MenuList />
                </PerfectScrollbar>
        </>
    );

    const container = window !== undefined ? () => window.document.body : undefined;

    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 }, width: drawerWidth }} aria-label="mailbox folders">
            <Drawer
                container={container}
                variant='persistent'
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        background: theme.palette.background.default,
                        color: '#406599',
                        borderRight: 'none',
                        [theme.breakpoints.up('md')]: {
                            top: '64px'
                        }
                    }
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </Box>
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};

export default Sidebar;
